import React from "react";
import { Button, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

import ResponsiveDialog from "components/dialogs/ResponsiveDialog";
import { useTranslation } from "react-i18next";

interface DeleteConfirmationProps {
  cancelButtonLabel?: string;
  deleteButtonLabel?: string;
  onClose(result: boolean): void;
  promptText?: string;
  title?: string;
}

export default function DeleteConfirmation(props: DeleteConfirmationProps): React.JSX.Element {
  const { i18n } = useTranslation();

  const cancelButtonLabel = props.cancelButtonLabel || i18n.t("cancel");
  const deleteButtonLabel = props.deleteButtonLabel || i18n.t("delete");
  const promptText = props.promptText || i18n.t("delete-confirmation.prompt-text");
  const title = props.title || i18n.t("delete-confirmation.title");

  return (
    <ResponsiveDialog maxWidth="xs" open={true}>
      <DialogTitle>
        <Stack direction="row" sx={{
          alignItems: "center"
        }}>
          <Typography variant="h4" sx={{
            flex: 1
          }}>
            {title}
          </Typography>
          <Button color="secondary" onClick={() => props.onClose(false)} sx={{minWidth: 0, padding: 0}}>
            <CloseIcon />
          </Button>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography>
          {promptText}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={() => props.onClose(false)} size="small" variant="contained">
          {cancelButtonLabel}
        </Button>
        <Button color="error" onClick={() => props.onClose(true)} size="small" variant="contained">
          {deleteButtonLabel}
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  );
}